import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {BacnetDeviceService} from "../../../../services/bacnet-device.service";
import {BacnetDevice} from "../../../../domain/bacnet-device";
import {MatDrawer} from "@angular/material/sidenav";
import {
  BacnetDatapointConfiguratorTableComponent
} from "../bacnet-datapoint-configurator-table/bacnet-datapoint-configurator-table.component";
import {BacnetDeviceTableComponent} from "../bacnet-device-table/bacnet-device-table.component";

@Component({
  selector: 'eis-gateway-bacnet-device-configurator',
  templateUrl: './bacnet-device-configurator.component.html',
  styleUrls: ['./bacnet-device-configurator.component.scss']
})
export class BacnetDeviceConfiguratorComponent implements OnInit {

  @Input()
  public gatewaySerial: string;

  @Input()
  public tenant: string;

  @ViewChild('drawer') drawer: MatDrawer
  @ViewChild(BacnetDeviceTableComponent) devicesTable:BacnetDeviceTableComponent

  public selectedDevice: BacnetDevice|null;


  constructor(
    private bacnetService: BacnetDeviceService,
  ) {
  }

  ngOnInit(): void {
  }


  async deviceSelectedEventHandler(selectedDevice: BacnetDevice) {
    this.selectedDevice = selectedDevice;
    await this.drawer.open()
  }

 async   closeDrawerEventHandler($event: void) {
  await  this.drawer.toggle()
   this.selectedDevice=null
   this.devicesTable.getBacnetDevices()
  }
}
